<div class="flex h-full">
  <div class="flex-1 flex items-center justify-center p-10" style="background: linear-gradient(180deg, #A44002 0%, #A64000 46.35%, #9D3A01 100%);">
    <img src="assets/mars-complete.png" alt="">
  </div>
  <div class="flex-1 flex flex-col items-center justify-center gap-y-16 text-center px-20">
    <div>
      <h1 class="text-[40px] font-extrabold text-[#652901] mb-1">M.A.R.S</h1>
      <p class="text-secondary text-base">Multi Asset Recommendation System</p>
    </div>
    <div>
      <h2 class="text-primary text-2xl font-bold mb-4">Well Done!!</h2>
      <p class="text-secondary text-base">You have successfully created a dynamic portfolio management tool, pat yourself on the back.</p>
    </div>
    <button class="btn py-3 px-[72px]" routerLink="/">Manage & Chill</button>
  </div>
</div>